import { motion } from "motion/react";
import { DiamondLogo } from "../components/home/DiamondLogo";
import { StatCounters } from "../components/home/StatCounters";
import { LaunchRail } from "../components/home/LaunchRail";
import { RecentActivity } from "../components/home/RecentActivity";
import { HeroTerminal } from "../components/home/HeroTerminal";

type Props = {
  projectName: string;
};

export function HomeSurface({ projectName }: Props) {
  return (
    <main className="ui-shell ui-home home-mission">
      {/* Background grid overlay */}
      <div className="home-mission__grid" />

      {/* Hero region */}
      <section className="home-hero">
        <div className="home-hero__logo-region">
          <DiamondLogo size={140} />
          <motion.div
            className="home-hero__identity"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h1 className="home-hero__title">
              <span className="home-hero__title-mark">Open</span>Tool
            </h1>
            <p className="home-hero__subtitle">Runtime Mission Control</p>
          </motion.div>
        </div>

        <motion.div
          className="home-hero__status-strip"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <span className="home-hero__status-pill home-hero__status-pill--live">
            <span className="home-hero__status-dot" />
            runtime active
          </span>
          <span className="home-hero__status-pill">
            project: {projectName}
          </span>
          <span className="home-hero__status-pill">
            mcp bridge ready
          </span>
        </motion.div>
      </section>

      {/* Stats row */}
      <section className="home-stats-row">
        <StatCounters />
      </section>

      {/* Main content: launch rail + activity feed */}
      <section className="home-body">
        <div className="home-body__primary">
          <LaunchRail projectName={projectName} />
        </div>
        <div className="home-body__secondary">
          <div className="home-body__terminal">
            <HeroTerminal />
          </div>
          <RecentActivity />
        </div>
      </section>
    </main>
  );
}
